import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { utilService } from 'services/util-service';

interface MapInformationProps {
  curRoom?: any;
}

const MapInformationOverlay = ({ curRoom }: MapInformationProps) => {
  const elapsedMinutes = (): any => {
    const timeDiff =
      new Date().getTime() - new Date(curRoom.accDate.replaceAll('-', '/') + ' ' + curRoom.accTime).getTime();
    return Object.is(timeDiff, NaN) || timeDiff < 0 ? '0' : Math.floor(timeDiff / 1000 / 60);
  };
  const [time, setTime] = useState(elapsedMinutes());

  useEffect(() => {
    const clock = setInterval(() => {
      setTime(elapsedMinutes());
    }, 60000);
    return () => clearInterval(clock);
  });

  return (
    <MapOverlayGpxInfo>
      <ul className="popup-content">
        {/* <li style={{ fontWeight: '700' }}>해양사고정보</li> */}
        <li>{curRoom.accDtl}</li>
        <li>
          {curRoom.accDate} {curRoom.accTime} ({time}분 경과)
        </li>
        <li>
          {utilService.convertToDms(curRoom.lat, false)} {utilService.convertToDms(curRoom.lng, true)}
        </li>
      </ul>
    </MapOverlayGpxInfo>
  );
};

const MapOverlayGpxInfo = styled.div`
  position: absolute;
  top: 5px;
  left: 5px;
  max-width: 90%;
  padding: 0.5rem;
  // height: 4rem;
  border-radius: 0.3125rem;
  border: none;
  background: rgba(0, 0, 0, 0.7);
  font-family: 'Noto Sans CJK KR';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  color: #ffffff;

  z-index: 1;
  .popup-content {
    position: relative;
    list-style: none;
    margin: unset;
    padding: 0 0;
    font: 14px 'kopubM';
    pointer-events: auto;
  }
  .popup-content > li {
    padding: 4px 0;
    padding-right: 1vw;
  }
`;

export default MapInformationOverlay;
